import React from 'react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="pt-20 pb-16 px-4 max-w-4xl mx-auto text-center" data-id="element-113">
      <div className="inline-block bg-neutral-900 border border-neutral-800 rounded-full px-4 py-1.5 text-sm font-medium text-neutral-300 mb-8" data-id="element-114">
        💪 KIT LIBERA TU MENTE™
      </div>

      <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight mb-6 leading-tight" data-id="element-115">
        Todo tu sistema de vaciado mental.{' '}
        <span className="text-brand-accent block mt-2" data-id="element-116">Listo. Desde hoy.</span>
      </h1>

      <div className="my-10 md:my-14 flex justify-center" style={{
      minHeight: '300px',
      aspectRatio: '1/1',
      maxWidth: '665px',
      margin: '2.5rem auto 3.5rem'
    }} data-id="element-117">
        <img src="https://cdn.magicpatterns.com/uploads/rqeGM6sfqo5s1gDjEt9sWQ/mockup.webp" alt="Kit Libera Tu Mente™ — 4 Tomos + 4 Bonos" width={665} height={665} fetchPriority="high" decoding="async" className="w-full max-w-xl md:max-w-2xl drop-shadow-[0_0_40px_rgba(245,197,24,0.15)]" data-id="element-118" />
      </div>

      <div className="space-y-2 mb-8" data-id="element-119">
        <p className="text-xl md:text-2xl font-medium text-neutral-200" data-id="element-120">
          KIT LIBERA TU MENTE™ — Sistema Integral de Claridad Mental
        </p>
        <p className="text-lg text-brand-accent font-medium" data-id="element-121">
          El sistema N°1 para profesionales saturados — Resultados desde el día
          1
        </p>
      </div>

      <p className="text-neutral-400 text-lg max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-122">
        Claridad + protocolo + vaciado cognitivo + descanso real listos para
        usar. Sin más bucles mentales. Sin más domingos con la cabeza llena. Sin
        más fatiga invisible.
      </p>

      <div className="flex flex-wrap justify-center gap-3 mb-12" data-id="element-123">
        <span className="bg-neutral-900 border border-neutral-800 px-4 py-2 rounded-full text-sm font-medium flex items-center gap-2" data-id="element-124">
          📄 100% PDF
        </span>
        <span className="bg-neutral-900 border border-neutral-800 px-4 py-2 rounded-full text-sm font-medium flex items-center gap-2" data-id="element-125">
          ⚡ Acceso en 5 min
        </span>
        <span className="bg-neutral-900 border border-neutral-800 px-4 py-2 rounded-full text-sm font-medium flex items-center gap-2" data-id="element-126">
          🧠 Para cualquier nivel de saturación
        </span>
      </div>

      <button onClick={scrollToPricing} className="bg-brand-accent hover:bg-brand-accentHover text-black font-bold text-xl md:text-2xl py-5 px-10 rounded-full transition-transform hover:scale-105 active:scale-95 shadow-[0_0_40px_rgba(245,197,24,0.3)] w-full md:w-auto mb-8" data-id="element-127">
        💪 → QUIERO MI KIT AHORA
      </button>

      <div className="flex flex-wrap justify-center gap-6 text-sm text-neutral-400 font-medium" data-id="element-128">
        <span className="flex items-center gap-2" data-id="element-129">🛡️ Garantía 7 días</span>
        <span className="flex items-center gap-2" data-id="element-130">🔒 Pago seguro</span>
        <span className="flex items-center gap-2" data-id="element-131">
          💳 Tarjeta — Transferencia — Bizum
        </span>
      </div>
    </div>;
}